function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useMemo, useState } from 'react';
import { bool, arrayOf, func, number, object, oneOf, oneOfType, shape, string } from 'prop-types';
import { v4 as uuid } from 'uuid';
import { styled } from '@mui/material/styles';
import { Apps, SovosLogo } from 'mosaic-react-icons';
import cloneDeep from 'lodash.clonedeep';
import BaseIcon from "./BaseIcon";
import Switcher from "../switcher/Switcher";
import { square } from "../../utils/stylesHelpers";
import treeListItemTypes from "../../../sovos-tree-list/helpers/itemTypes";
import { useCustomTheme } from "../../../sovos-custom-theme-context";
import customThemeColors from "../../custom-themes/custom-theme-colors";
var StyledSwitcher = styled(Switcher)({
  flex: '0 0 auto',
  '& .sovosSwitcher__button': {
    minWidth: 0,
    width: 'auto'
  }
});
var ButtonContents = styled('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'selectedTheme';
  }
})(function (_ref) {
  var _overrides$sovosNavig, _overrides$sovosNavig2;
  var selectedTheme = _ref.selectedTheme,
    _ref$theme = _ref.theme,
    overrides = _ref$theme.overrides,
    palette = _ref$theme.palette,
    themeShape = _ref$theme.shape,
    spacing = _ref$theme.spacing;
  return _objectSpread({
    alignItems: 'center',
    background: selectedTheme === customThemeColors[0].title ? "linear-gradient(45deg, ".concat(palette.primary.dark, ", ").concat(palette.primary.main, ")") : (_overrides$sovosNavig = overrides === null || overrides === void 0 || (_overrides$sovosNavig2 = overrides.sovosNavigation) === null || _overrides$sovosNavig2 === void 0 ? void 0 : _overrides$sovosNavig2.highlights) !== null && _overrides$sovosNavig !== void 0 ? _overrides$sovosNavig : palette.primary.main,
    borderRadius: themeShape.borderRadius,
    display: 'flex',
    justifyContent: 'center',
    marginRight: 0
  }, square(spacing(5)));
});
var SovosIcon = styled(BaseIcon)(function (_ref2) {
  var palette = _ref2.theme.palette;
  return {
    position: 'relative',
    '& path': {
      fill: palette.primary.contrastText
    }
  };
});
var ProductMenu = function ProductMenu(_ref3) {
  var label = _ref3.label,
    onSelectProduct = _ref3.onSelectProduct,
    PopoverProps = _ref3.PopoverProps,
    products = _ref3.products,
    selectedProduct = _ref3.selectedProduct;
  var state = useCustomTheme();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  var showAppsIcon = hovered;
  var items = useMemo(function () {
    var getMenuItem = function getMenuItem(product) {
      var id = product.id || product.name || uuid();
      var item = _objectSpread({
        id: id,
        content: product.name
      }, product);
      if (product.nestedProducts) {
        item.nestedItems = product.nestedProducts.map(getMenuItem);
      }
      return item;
    };
    return cloneDeep(products).map(getMenuItem);
  }, [products]);
  var selectedItem = useMemo(function () {
    return _objectSpread({
      id: selectedProduct.id || selectedProduct.name
    }, selectedProduct);
  }, [selectedProduct]);
  var productIcon = selectedProduct.icon ? /*#__PURE__*/React.createElement(BaseIcon, {
    element: selectedProduct.icon,
    isVisible: !showAppsIcon
  }) : /*#__PURE__*/React.createElement(SovosIcon, {
    element: SovosLogo,
    isVisible: !showAppsIcon
  });
  var buttonContents = /*#__PURE__*/React.createElement(ButtonContents, {
    onPointerOver: function onPointerOver() {
      return setHovered(true);
    },
    onPointerOut: function onPointerOut() {
      return setHovered(false);
    },
    selectedTheme: state === null || state === void 0 ? void 0 : state.selectedTheme
  }, /*#__PURE__*/React.createElement(BaseIcon, {
    element: Apps,
    isVisible: showAppsIcon
  }), productIcon);
  return /*#__PURE__*/React.createElement(StyledSwitcher, {
    buttonContents: buttonContents,
    buttonTooltip: label,
    className: "sovosNavigation__productSwitcher",
    items: items,
    onSelectItem: onSelectProduct,
    PopoverProps: PopoverProps,
    selectedItem: selectedItem
  });
};
ProductMenu.propTypes = {
  label: string.isRequired,
  PopoverProps: object,
  /**
   * Array of objects, each with
   *
   * - `id` string or number. Required if there is any chance the names may
   *   not be unique. Not required for dividers and headers.
   * - `name` string
   * - `disabled` bool
   * - `type` string, one of , 'DIVIDER', or 'HEADER', or undefined
   * - `nestedProducts` array of objects
   */
  products: arrayOf(shape({
    id: oneOfType([number, string]),
    name: function name(_ref4, _propName, component) {
      var _name = _ref4.name,
        type = _ref4.type;
      if (type === 'DIVIDER') return null;
      if (typeof _name === 'string') return null;
      return new Error("Invalid products array supplied to ".concat(component, ". Each item must have a `name` unless its type is 'DIVIDER' or 'HEADER'."));
    },
    disabled: bool,
    type: oneOf(Object.values(treeListItemTypes))
  })).isRequired,
  selectedProduct: object,
  /**
   * An icon representing the current product
   */
  onSelectProduct: func.isRequired
};
export default ProductMenu;